import { render, staticRenderFns } from "./EmailTimelineTable.vue?vue&type=template&id=23fd5943&scoped=true"
import script from "./EmailTimelineTable.vue?vue&type=script&lang=js"
export * from "./EmailTimelineTable.vue?vue&type=script&lang=js"
import style0 from "./EmailTimelineTable.vue?vue&type=style&index=0&id=23fd5943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd5943",
  null
  
)

export default component.exports